module.exports = __webpack_public_path__ + "img/hero-img.22366f04.webp";